export type { StickyWhatsappCTAProps } from './sticky-whatsapp-cta'
export { StickyWhatsappCTA } from './sticky-whatsapp-cta'
